module.exports = __webpack_public_path__ + "static/img/product_link_active.bcc9f00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/product_link_active.png
// module id = orf6
// module chunks = 134